<!DOCTYPE html>
@if (url || redirectlink || isCheckOutCom || isPaymill) {
<ion-content scrollY="false">
  <ion-row class="title-head">
    <ion-col size="10">
      <p class="status-title">{{ "payment.Add" | translate }}</p>
    </ion-col>
    <ion-col size="2">
      <ion-icon name="close-circle" class="close-icon" (click)="goHome()"></ion-icon>
    </ion-col>
  </ion-row>
  @if (isCheckOutCom) {
  <div style="
    padding: 0.3vh;
    border-radius: 2vh;
    min-height: 25vh;
    width: 97%;
    margin-left: 1.5%;
    margin-top: 1vh;
    height: auto;
    position: relative;
    background-color: #fff;
  " class="checkout_gateway">
    @if (isCheckoutComform) {
    <form id="payment-form" (submit)="onSubmit($event)">
      <ng-container>
        <div class="one-liner flow-entry">
          <div id="cko-flow-container" class="cko-flow-container"></div>
        </div>
        @if (errorMessage) {
        <div class="message">
          @if (isCheckoutLoadingMessage(errorMessage) && showCheckOutComSpinner && !checkoutFlowReady) {
          <ion-spinner name="lines-small" class="checkout-inline-spinner"></ion-spinner>
          }
          <p [class.loading-message]="isCheckoutLoadingMessage(errorMessage)" [class.error-message]="!isCheckoutLoadingMessage(errorMessage)">{{ errorMessage }}</p>
        </div>
        } @else if (!errorMessage && showCheckOutComSpinner && !checkoutFlowReady) {
        <div class="timer-section-loader" aria-live="polite" aria-busy="true">
          <ion-spinner name="lines-small" class="timer-section-spinner"></ion-spinner>
        </div>
        }
      </ng-container>
    </form>
    }
    @defer (when redirectlink) {
    <iframe
      [ngStyle]="{ 'height': isCheckoutComform ? '0vh' : '100vh', 'pointer-events': isCheckoutComform ? 'none' : 'auto' }"
      style="border: 0; width: 100%; padding: 1vh;"
      id="checkoutAuthorizationIframe"
      name="checkoutAuthorizationIframe"
      [src]="redirectlink"
      #checkOutIframe>
    </iframe>
    }
    @if (showCheckOutComSpinner && (!checkoutFlowReady || cardTokenizedCalled)) {
    <img class="checkout-flow-loader"
      src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/randomAsset%2Fblue_bg.gif?alt=media"
      alt="loading" />
    }
  </div>
  }
  @if (isPaymill) {
  <div>
    <div class="payment-add-form"
      [ngStyle]="{ visibility: !paymentDone ? 'hidden' : 'visible', height: !paymentDone ? '0px' : '100vh' }">
      <iframe style="border: 0; width: 100%; height: 100vh; padding: 1vh" #iframe id="myCustomIframe1"
        name="myCustomIframe1" (load)="load()"
        sandbox="allow-forms allow-modals allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation">
      </iframe>
    </div>
  </div>
  }
  @if (!hideSpinner) {
  <div style="text-align: center">
    <ion-spinner name="lines-small" diameter="40" style="color: rgb(12, 174, 12); margin-top: 12vh"> </ion-spinner>
  </div>
  }
  @if (!paymentDone) {
  <div class="payment-add-form"
    [ngStyle]="{ visibility: !paymentDone ? 'visible' : 'hidden', height: !paymentDone ? '100vh' : '0px' }">
    <form action="{{ origin + '/r' }}" class="paymentWidgets" data-brands="VISA MASTER"></form>
  </div>
  }
</ion-content>
}
